import React from 'react'

import { Navigation, StyledHeader, Title, GrandPrix, MusicToggle } from './styles'

import { MdVolumeOff, MdVolumeUp } from 'react-icons/md';

function Header (props){
  const theme = process.env.REACT_APP_GRANDPRIX || "Spyro and Friends"
  const timeRemaining = '2 days'
  return (
    <StyledHeader>
      <Navigation>
        { props.children }
      </Navigation>
      <Title>
        <GrandPrix>Grand Prix { theme }</GrandPrix>
        <MusicToggle onClick={ props.toggle }>
          { props.music ? <MdVolumeUp/> : <MdVolumeOff/>}
        </MusicToggle>
        {/* <TimeRemaining>Time Remaining:  { timeRemaining }</TimeRemaining> */}
      </Title>
    </StyledHeader>
  )
}

export default Header